import ValidationEvidencePanel from '../components/evolution/ValidationEvidencePanel';

export default function Validation() {
  return <ValidationEvidencePanel />;
}
